import api from '@/modules/api.service';
import axios from 'axios';
import { API_URL } from '@/shared/constants/strings';
import { Endpoints } from '@/shared/constants/endpoints';

export interface CandidatoTokenResponse {
  valid: boolean;
  personCPF?: string;
}

export class CandidatoAuthService {
  async solicitarTokenPorCPF(cpf: string): Promise<void> {
    try {
      const response = await api.post(Endpoints.AUTH + '/candidato/token', { input: cpf });
      return response.data;
    } catch (error: any) {

      // Lançar o erro para que o componente possa exibir a mensagem ao usuário
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }

      // Para erros de rede ou outros problemas, lançar erro genérico
      throw new Error('Erro ao solicitar acesso. Tente novamente mais tarde.');
    }
  }

  async validarToken(token: string): Promise<CandidatoTokenResponse> {
    try {
      // Usar instância do axios sem interceptors para evitar redirecionamento
      const candidatoApi = axios.create({
        baseURL: API_URL as string,
      });

      const response = await candidatoApi.post<{ personCPF: string }>(
        Endpoints.AUTH + '/candidato/token/info',
        { input: token },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }
      );
      return { valid: true, personCPF: response.data.personCPF };
    } catch (error: any) {
      // Não usar ValidateAxiosError aqui para evitar redirecionamento
      if (error.response) {
        return { valid: false };
      }
      throw error;
    }
  }

  async listarMeusProcessos(token: string): Promise<any[]> {
    try {

      // Criar uma instância do axios sem interceptors para não interferir com o redirecionamento
      const candidatoApi = axios.create({
        baseURL: API_URL as string,
      });

      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json;charset=UTF-8',
      };

      const response = await candidatoApi.get(Endpoints.CANDIDATO + '/meus-processos', {
        headers,
      });

      return response.data;
    } catch (error: any) {

      if (error.response?.status === 401) {
        throw new Error('Token inválido ou expirado. Faça login novamente.');
      }
      if (error.response?.status === 403) {
        throw new Error('Acesso negado. Verifique se você tem permissão para acessar esta página.');
      }
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Falha ao listar processos seletivos.');
    }
  }
}

